import { useContext } from "react";
import { ChatContext } from "../providers";

/**
 * Hook that returns the chat context value
 * 
 * @returns The chat context
 */
const useChat = () => {
  const chatContext = useContext(ChatContext);

  if (!chatContext) {
    throw new Error("useChat must be used within a ChatProvider");
  }

  return chatContext;
};

export default useChat;
